import React from "react";
import { IStyledSVGIconProps, StyledSVGIcon } from "./icon.style";

export const ComputerAccessoriesMarketplaceIcon: React.FC<IStyledSVGIconProps> =
  (props) => {
    return (
      <StyledSVGIcon
        width="37"
        height="36"
        viewBox="0 0 37 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g>
          <path
            d="M34.25 4V2C34.25 0.9 33.35 0 32.25 0H28.25C27.15 0 26.25 0.9 26.25 2V4C25.15 4 24.25 4.9 24.25 6V12C24.25 13.1 25.15 14 26.25 14H28.25V27.82C28.25 29.9 26.73 31.78 24.67 31.98C22.27 32.22 20.25 30.34 20.25 28V8.28C20.25 4.02 17.03 0.3 12.77 0.02C8.11 -0.28 4.25 3.4 4.25 8V22H2.25C1.15 22 0.25 22.9 0.25 24V30C0.25 31.1 1.15 32 2.25 32V34C2.25 35.1 3.15 36 4.25 36H8.25C9.35 36 10.25 35.1 10.25 34V32C11.35 32 12.25 31.1 12.25 30V24C12.25 22.9 11.35 22 10.25 22H8.25V8.18C8.25 6.1 9.77 4.22 11.83 4.02C14.23 3.78 16.25 5.66 16.25 8V27.72C16.25 31.98 19.47 35.7 23.73 35.98C28.39 36.28 32.25 32.6 32.25 28V14H34.25C35.35 14 36.25 13.1 36.25 12V6C36.25 4.9 35.35 4 34.25 4Z"
            fill="black"
            fill-opacity="0.54"
          />
        </g>
      </StyledSVGIcon>
    );
  };